/**
 * Central dayjs plugin registration. Import this once for its side effects at
 * the app entry point (`index.tsx`) so every `dayjs(...)` call across the app
 * has the plugins available:
 *   - utc + timezone → the Eastern-time display rule (see utils/formatters).
 *   - relativeTime   → `.fromNow()` (replaces date-fns `formatDistanceToNow`).
 *
 * `dayjs.extend` is idempotent, so utils/formatters keeping its own utc/timezone
 * extends (for unit-test isolation) is harmless.
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export default dayjs;
